import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
	GET_MAKE_UP_PUNCH_RULE_SETTING_CALL,
	GET_MAKE_UP_PUNCH_RULE_SETTING_DONE,
	GET_MAKE_UP_PUNCH_RULE_SETTING_FAIL,
} from '@src/store/types';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialSetting = {
	make_up_punch_enabled: false,
	apply_within_days_limit: false,
	apply_within_days: 0,
};

const initialState = {
	setting: initialSetting,
	getMakeUpPunchRuleSettingSideEffect: defaultSideEffectState,
};

export default handleActions({
	[GET_MAKE_UP_PUNCH_RULE_SETTING_CALL](state) {
		return update(state, {
			getMakeUpPunchRuleSettingSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_MAKE_UP_PUNCH_RULE_SETTING_DONE](state, { payload: { res } }) {
		return update(state, {
			setting: { $set: res || initialSetting },
			getMakeUpPunchRuleSettingSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_MAKE_UP_PUNCH_RULE_SETTING_FAIL](state, { payload }) {
		return update(state, {
			getMakeUpPunchRuleSettingSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
}, initialState);
